export default __webpack_public_path__ + "static/media/avatar.454d1bed.svg";